import * as React from "react";
import { SVMLogo } from "./SVMLogo";
import { IsSoundmouse } from "../../tools/toolkit";
import { SMLogo } from "./SMLogo";

export class AppLogo extends React.Component {
    render() {
        if (IsSoundmouse)
            return (
                <SMLogo />
            );

        return (
            <SVMLogo />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/AppLogo.js